export default "__VITE_ASSET__DoyCgdXa__"